export const priceTypeFromRole = {
	reader: "reader",
	subcontractor: "production",
	recorder: "record",
	editor: "edit",
	proofer: "proof",
	manager: "manage",
};
